import React from 'react';

interface EstadisticasCardProps {
  titulo: string;
  valor: string | number;
  icono: React.ReactNode;
  color: 'blue' | 'green' | 'purple' | 'red';
  delay?: number;
}

const gradientClasses = {
  blue: 'card-gradient-blue',
  green: 'card-gradient-green',
  purple: 'card-gradient-purple',
  red: 'card-gradient-red'
};

const EstadisticasCard: React.FC<EstadisticasCardProps> = ({
  titulo,
  valor,
  icono,
  color,
  delay = 0
}) => {
  return (
    <div
      className={`
        ${gradientClasses[color]}
        rounded-xl
        p-6
        shadow-[0_4px_20px_rgba(0,0,0,0.08)]
        transition-all
        duration-200
        ease-in-out
        hover:translate-y-[-4px]
        hover:shadow-[0_8px_30px_rgba(0,0,0,0.12)]
        opacity-0
        animate-fade-in
      `}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm font-medium text-gray-600">{titulo}</p>
          <p className="text-2xl font-bold mt-1 text-gray-900">{valor}</p>
        </div>
        {icono}
      </div>
    </div>
  );
};

export default EstadisticasCard;